/**
* @Name: KeyValue
* @Creation Date: July 31 2017
* @Author: sbaireddy
* @Version: 1.0 :
*/
export class KeyValue {
    key: string;
    value: any;

    // constructor
   constructor(key: string, value: any) {
      this.key = key;
      this.value = value;
   }
    getKey(): string { return this.key; }
    setKey(key: string): void { this.key = key; }

    getValue(): any { return this.value; }
    setValue(value: any): void { this.value = value; }

    setKeyValue(key: string, value: any ): void {
        this.key = key;
        this.value = value;
    }
}

export interface IKeyValue {
    key: string;
    value: any;
}
